/*
  NS FAQ (sections/nb-ns-faq.liquid)

  Items beyond the "Visible items" setting render with
  .nb-nf__item--hidden. The View more button reveals them and removes itself.
  Click handling is delegated, so it also works after editor section reloads.
*/
(function () {
  'use strict';

  var ROOT_SELECTOR = '[data-nb-nf]';
  var MORE_SELECTOR = '[data-nb-nf-more]';
  var HIDDEN_CLASS = 'nb-nf__item--hidden';

  document.addEventListener('click', function (event) {
    var button = event.target.closest(MORE_SELECTOR);
    if (!button) {
      return;
    }

    var root = button.closest(ROOT_SELECTOR);
    if (!root) {
      return;
    }

    root.querySelectorAll('.' + HIDDEN_CLASS).forEach(function (el) {
      el.classList.remove(HIDDEN_CLASS);
    });
    button.remove();
  });
})();
